<template>
  <el-container class="manage-style">
    <el-header height="55px">
      <div class="nav-left">
        <img class="logo" src="../assets/logo.png" alt="Component Everything" title="Component Everything" @click="toGW" />
        <el-menu
          :default-active="defaultActive"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          :ellipsis="false"
          mode="horizontal"
        >
          <component
            v-for="(m,i) of menus"
            :is="m.id?'el-menu-item':'el-sub-menu'"
            :key="i"
            :index="i+''"
            :class="{
              active: defaultActive && defaultActive == i+''
            }"
            @click="menuClick(m)"
          >
            <template #title>
              <div class="menu-item" :class="{
                'menu-active': defaultActive && defaultActive.startsWith(i+'-')
              }">
                <font-awesome-icon class="m-icon" :icon="m.icon" />
                <span>{{ m.name }}</span>
              </div>
            </template>
            <el-menu-item
              v-for="(mm,j) of m.childs?m.childs:[]"
              :key="j"
              :index="i+'-'+j"
              :class="{
                active: defaultActive && defaultActive == i+'-'+j
              }"
              @click="menuClick(mm)"
            >{{ mm.name }}</el-menu-item>
          </component>
        </el-menu>
      </div>
      <div class="nav-right">
        <el-dropdown trigger="click" placement="bottom-end" @command="handleCommand">
          <div class="avatar-menu">
            <img class="avatar" src="../assets/images/avatar.png" />
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="info">个人信息</el-dropdown-item>
              <el-dropdown-item command="pwd">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出系统</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>
    <el-main class="main-container"><slot /></el-main>
    <!-- <el-footer height="30px" style="border-top: 1px solid #f0f0f0;box-shadow: 0px -4px 4px 0px #d2d2d233;">
      版权所有 ©湖北天码科技有限责任公司
    </el-footer> -->
  </el-container>
</template>

<script>
import config from '../config'

export default {
  name: 'ManageStyle',
  data() {
    return {
      defaultActive: undefined,
      isCollapse: false,
      menus: []
    }
  },
  created() {
    this.$auth.verify().then(() => {
      for (let i = 0; i < config.menus.length; i++) {
        if (config.menus[i].auth.indexOf(this.$auth.user.role) != -1) {
          this.menus.push(config.menus[i])
        }
      }
      for (let i = 0; i < this.menus.length; i++) {
        const m = this.menus[i]
        if (!m.id) {
          for (let j = 0; j < m.childs.length; j++) {
            const n = m.childs[j]
            if (n.id == this.$router.curPage) {
              this.defaultActive = i+'-'+j
              return
            }
          }
        } else if (m.id == this.$router.curPage) {
          this.defaultActive = i+''
          return
        }
      }
    })
    this.$router.onPathChange('ManageStyle', () => {
      for (let i = 0; i < this.menus.length; i++) {
        const m = this.menus[i]
        if (!m.id) {
          for (let j = 0; j < m.childs.length; j++) {
            const n = m.childs[j]
            if (n.id == this.$router.curPage) {
              this.defaultActive = i+'-'+j
              return
            }
          }
        } else if (m.id == this.$router.curPage) {
          this.defaultActive = i+''
          return
        }
      }
    })
  },
  methods: {
    toGW() {
      window.open('http://junesunray.com')
    },
    menuClick(m) {
      if (m.id) {
        this.$router.to(m.id)
      }
    },
    handleCommand(c) {
      if (c == 'info') {
        this.$router.to(this.$auth.user.role == 'customer' ? 'info' : 'pwd')
      } else if (c == 'pwd') {
        this.$router.to(this.$auth.user.role == 'customer' ? 'info' : 'pwd')
      } else {
        this.$auth.logout().then(() => {
          this.$router.to('login')
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .menu {
    overflow-y: scroll;
    width: 100%;
    height: 100%;
    padding-bottom: 100px;
    &::-webkit-scrollbar{
      width: 0px;
    }
    .el-menu-vertical-demo {
      margin-bottom: 100px;
    }
  }
  .main-container {
    padding: 0;
  }
</style>

<style lang="scss" scoped>
  $header-height: 55px;
  $footer-height: 30px;
  $aside-width: 200px;

  $menu-bg-color: #FA541C;

  .manage-style {
    .el-menu {
      border-right: 0;
      height: 55px;
      .m-icon {
        margin-right: 8px;
      }
      .el-menu-item {
        color: #606266;
        height: 55px;
        &:HOVER {
          background-color: #FFF2E8;
        }
      }
      .menu-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
      }
      .menu-active {
        color: #FA541C;
      }
      .active {
        background-color: #FFF2E8;
        color: #FA541C;
        border-bottom: 3px solid #FA541C;
      }
    }
  }

  .el-header{
    background-color: #fff;
    height: $header-height;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-bottom: 1px solid #F0F2F5;
    box-shadow: 0px 2px 3px -1px #dfdfdf;
    .nav-left {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      .title {
        font-size: 15px;
        font-weight: bold;
        width: 180px;
      }
      .logo {
        width: 175px;
        height: 40px;
        margin-right: 5px;
        object-fit: contain;
        cursor: pointer;
      }
    }
    .nav-right {
      width: auto;
      height: 100%;
      display: flex;
      align-items: stretch;
      .avatar-menu {
        display: flex;
        align-items: center;
        height: 100%;
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          border: #FCFCFC 1px solid;
        }
      }
    }
  }
  .el-aside {
    background-color: #FFF;
    height: calc(100vh - #{ $header-height });
    width: $aside-width;
    overflow: hidden;
    border-right: solid 1px #e6e6e6;
  }
  .el-main {
    background-color: #0022550f;
    height: calc(100vh - #{ $header-height });
    overflow-x: hidden;
    overflow-y: auto;
    padding: 15px 12px;
  }
  .el-footer {
    background-color: #fffbf7;
    color: #606266;
    line-height: $footer-height;
    height: $footer-height;
    text-align: center;
    overflow: hidden;
    font-size: 8px;
  }
</style>